import { PencilAltIcon } from "@heroicons/react/solid";
import { TrendingUpTwoTone } from "@material-ui/icons";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

// import { useSnackbar } from "@/features/common/hooks/snackbar/useSnackbar";
import { RouteName } from "@/consts";
import { TouchableView } from "@/features/common/components/tailwind/TouchableView";
import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import {
  FeatureNameEnum, // useCreatePostMutation,
} from "@/generated/generated-hooks";

// import { createPostHelper } from "../helper";
interface NewPostPageButtonProps {
  disabled?: boolean;
}

export const NewPostPageButton: React.FC<NewPostPageButtonProps> = (props) => {
  const router = useRouter();
  const { isEnabled, loading: loadingFeatures } = useFeatureEnabled();
  // const [createPost, { loading }] = useCreatePostMutation();
  // const { openSnackbar } = useSnackbar();
  const isNftEnabled = isEnabled(FeatureNameEnum.Nft);
  const { t } = useTranslation("common");
  const [routeChanging, setRouteChanging] = useState(false);
  const disabled =
    // loading ||
    loadingFeatures || isNftEnabled
      ? router.route === RouteName.ContentSelection
      : router.route === RouteName.NewPostRoute ||
        props.disabled ||
        routeChanging;

  const onRouteChangeStart = (e) => setRouteChanging(true);
  const onRouteChangeEnd = (e) => setRouteChanging(false);

  useEffect(() => {
    router.events.on("routeChangeStart", onRouteChangeStart);
    router.events.on("routeChangeComplete", onRouteChangeEnd);

    return () => {
      router.events.off("routeChangeStart", onRouteChangeStart);
      router.events.off("routeChangeComplete", onRouteChangeEnd);
    };
  }, [router.events]);

  const onClick = () => {
    // if (isNftEnabled) {
    router.push(RouteName.ContentSelection);
    //   return;
    // }
    // createPostHelper({
    //   router,
    //   t,
    //   createPost,
    //   openSnackbar,
    //   onClickLocation: "siteTopNavigation",
    // });
  };

  if (disabled) return <PencilAltIcon className="w-7 h-7 text-gray-300" />;

  return (
    <TouchableView onClick={onClick}>
      <PencilAltIcon className="w-7 h-7 text-primary" />
    </TouchableView>
  );
};
